export default {
  headbar: {
    title: '',
    button: {
      start: { label: 'Get started' },
      login: { label: 'Log in' }
    },
    message: {
      exit: 'Are you sure to exit system?'
    }
  },
  footer: {
    static: {
      qrcode: { label: 'Scan me' },
      qrsales: { label: 'WeCom' },
      qrpubacc: { label: 'PubAccount' },
      copyright: { label: '©️2023 Shenzhen Nanzoom Technology Co.,Ltd.' },
      contact: { label: 'Contact Us', phone: '(086) 133 0296 1084', mail: 'bruce at uzoombox.com' }
    }
  },
  App: {
    metaInfo: {
      title: 'uzoomBox - Your zoomable private cloud',
      keywords: 'uzoombox, private cloud, enterprise cloud disk',
      description: 'Make your zoomable private cloud by uzoombox.'
    }
  },
  Home: {
    metaInfo: {
      title: 'uzoomBox - Your zoomable private cloud | Home',
      keywords: 'uzoombox, private cloud, enterprise cloud disk',
      description: 'Make your zoomable private cloud by uzoombox.'
    },
    slogan: {
      static: {
        oneword: { label: 'Your zoomable<br/>private cloud' },
        keywords: { label: 'Security, Privacy, Self-hosted, Extensions' }
      },
      button: {
        start: { label: 'Get started' },
        contact: { label: 'Contact us' }
      }
    },
    scene: {
      static: {
        security: { label: 'Future Working - Place', detail: 'Work at anywhere' },
        privacy: { label: 'Future Working - Time', detail: 'Work restore from any timeline' },
        extension: { label: 'Future Working - Terminal', detail: 'Work on any device' }
      }
    },
    feature: {
      security: {
        label: 'Security',
        system: {
          label: 'More Security Cloud Platform',
          details: 'Use the reliable Linux system<br/>Firewall, Defender, Anti-spam'
        },
        data: {
          label: 'More Security Data Manage',
          details: 'Rollback version with History<br/>Restore with Trashbin'
        },
        service: {
          label: 'More Security Service System',
          details: 'Strong password<br/>Active defense'
        }
      },
      privacy: {
        label: 'Privacy',
        system: {
          label: 'Prviate Cloud',
          details: 'Data assets own to you<br/>Data assets used by you'
        },
        data: {
          label: 'Public & Private Document',
          details: 'Unauthorized users cannot access public documents<br/>Others cannot access my documents'
        },
        service: {
          label: 'Safety Deposit Box',
          details: 'Encrypted storage<br/>Two-way verification'
        }
      },
      hosted: {
        label: 'Self-hosted',
        system: {
          label: 'Space Unlimited',
          details: 'Add storage by yourself'
        },
        data: {
          label: 'Account Unlimited',
          details: 'Add users by yourself'
        },
        service: {
          label: 'Model Unlimited',
          details: 'Try the latest models after system upgraded'
        }
      },
      extension: {
        label: 'Extensions',
        system: {
          label: 'Application Store',
          details: 'File templates, and more'
        },
        data: {
          label: 'System Intergration',
          details: 'Intergrate with your system, and more'
        },
        service: {
          label: 'And More',
          details: 'Develop based on your requirement'
        }
      }
    },
    starter: {
      label: 'Make a choice for your business',
      button: {
        contact: { label: 'Scan me' }
      },
      paas: {
        1: {
          label: 'Basic Version(PaaS)',
          price: { main: '¥39,800/Year', space: 'add storage: ¥8,000/TB/Year' },
          header: {
            key: { label: 'Service' },
            value: { label: 'Service Description' }
          },
          row: {
            1: { key: 'Object', value: 'Enterprise: less than 50 persons' },
            2: { key: 'Space', value: 'Storage: 1TB, can add more' },
            3: { key: 'Bandwidth', value: 'Bandwidth: 10Mbps' },
            4: { key: 'Account', value: 'Unlimited users' },
            5: { key: 'Model', value: 'Unlimited model use' },
            6: { key: 'Support', value: 'Technical support for free' }
          }
        },
        2: {
          label: 'Ultimate Version(PaaS)',
          price: { main: '¥169,800/Year', space: 'add storage: ¥8,000/TB/Year' },
          header: {
            key: { label: 'Service' },
            value: { label: 'Service Description' }
          },
          row: {
            1: { key: 'Object', value: 'Enterprise: less than 500 persons' },
            2: { key: 'Space', value: 'Storage: 10TB' },
            3: { key: 'Bandwidth', value: 'Bandwidth: 50Mbps' },
            4: { key: 'Account', value: 'Unlimited users' },
            5: { key: 'Model', value: 'Unlimited model use' },
            6: { key: 'Support', value: 'Technical support for free' }
          }
        },
        3: {
          label: 'Software Service(Saas)',
          price: { main: '---/Year', space: 'add storage: ¥8,000/TB/Year' },
          header: {
            key: { label: 'Service' },
            value: { label: 'Service Description' }
          },
          row: {
            1: { key: 'Object', value: 'Enterprise: with your own cloud' },
            2: { key: 'Upgrade', value: 'Upgrade software to latest version for free' },
            3: { key: 'Support', value: 'Remote technical support for free' },
            4: { key: 'Space', value: 'Unlimited storage' },
            5: { key: 'Account', value: 'Unlimited users' },
            6: { key: 'Model', value: 'Unlimited model use' }
          }
        }
      }
    }
  },
  Page404: {
    content: '404: Page not found.'
  }
}
